import axios from 'axios'

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:8080/api'

const apiClient = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    }
})

// Add request interceptor for debugging
apiClient.interceptors.request.use(
    config => {
        // Remove any duplicate /api prefixes
        if (config.url?.startsWith('/api/')) {
            config.url = config.url.substring(4)
        }

        // Ensure URL doesn't have double slashes
        if (config.url?.startsWith('/')) {
            config.url = config.url.substring(1)
        }

        console.log('API Request:', {
            method: config.method,
            url: `${config.baseURL}/${config.url}`,
            data: config.data,
            params: config.params,
            headers: config.headers
        })
        return config
    },
    error => {
        console.error('Request Error:', error)
        return Promise.reject(error)
    }
)

// Add response interceptor for error handling
apiClient.interceptors.response.use(
    response => {
        console.log('API Response:', {
            status: response.status,
            data: response.data
        })
        return response
    },
    error => {
        if (error.response) {
            // Handle 401 Unauthorized errors
            if (error.response.status === 401) {
                // Clear local storage
                localStorage.removeItem('token')
                localStorage.removeItem('userInfo')

                // Clear auth header
                delete apiClient.defaults.headers.common['Authorization']

                // Redirect to login if not already there
                if (window.location.pathname !== '/login') {
                    window.location.href = '/login'
                }
                return Promise.reject(new Error('Session expired. Please log in again.'))
            }

            // Log the error response for debugging
            console.error('API Error Response:', {
                status: error.response.status,
                data: error.response.data,
                headers: error.response.headers
            })
        } else if (error.request) {
            console.error('API Error: No response received', error.request)
        } else {
            console.error('API Error:', error.message)
        }
        return Promise.reject(error)
    }
)

// Initialize auth header from localStorage
const token = localStorage.getItem('token')
if (token) {
    apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`
}

export { apiClient }
export default apiClient